import type { Resource } from '../../';
export const country_countries_ID: Resource = {"default":"Indonesia"};
